// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"2894af52","703":"887f6d39","787":"171417bb"}[chunkId] + ".chunk.js";
};